import Axios from 'axios';
import VueAxios from 'vue-axios';
import conf from 'src/config.js';
import store from 'src/store';


const axios = Axios.create({
  baseURL: `${conf.host}/api/`,
  timeout: 15000,
  headers: {'X-Origin': 'portal-ui'}
});

axios.interceptors.response.use((response) => {
  if(response.status === 401) {
       console.log("You are not authorized");
       store.user.data = null;
  }
  if (response && (response.status === 200) && response.data && response.data.data) return response.data.data
  return response;
}, (error) => {
  if (error.response && error.response.status && error.response.status === 401) {
      store.user.data = null;
      //router.push('/login');
  }
  if (error.response) {
      return Promise.reject(error.response.data);
  }
  console.error('axios middleware, error detected', error);
  error.error = true;
  return Promise.reject(error);
});

export default {
  install(Vue) {
    Vue.use(VueAxios, axios);
  }
};


/*
    if (error.response) {
      // Request made and server responded
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
*/